import type { AnalyticsObject, AnalyticsProperties } from '../types'

export interface ProviderParams {
  slug: string
  label: string
  affiliate?: boolean
  category?: { type: string }
  languages?: string[]
  reviews?: { monitoScore: number }
}

export class Provider implements AnalyticsObject {
  name: string
  properties: ProviderProperties
  constructor(provider: ProviderParams, clickType?: 'Added' | 'Removed') {
    this.name = clickType ? `Provider ${clickType}` : 'Provider'
    this.properties = mapProvider(provider)
  }
}

export function mapProvider(provider: ProviderParams): ProviderProperties {
  return {
    provider: {
      name: provider.label,
      slug: provider.slug,
      type: provider.category
        ? TYPES_MAP[provider.category.type as keyof typeof TYPES_MAP]
        : undefined,
      monitoScore: provider.reviews?.monitoScore || undefined,
      affiliateStatus:
        provider.affiliate === undefined
          ? 'N/A'
          : provider.affiliate
          ? ProviderAffiliateStatus.Affiliate
          : ProviderAffiliateStatus.NonAffiliate,
      availableLanguages: provider.languages,
    },
  }
}

export interface ProviderProperties extends AnalyticsProperties {
  provider: {
    name: string
    slug: string
    affiliateStatus?: ProviderAffiliateStatus | 'N/A'
    monitoScore: number | undefined
    type: ProviderType | undefined
    availableLanguages: string[] | undefined
  }
  clickType?: 'Added' | 'Removed'
}

enum ProviderAffiliateStatus {
  Affiliate = 'Affiliate',
  NonAffiliate = 'Non-affiliate',
}

enum ProviderType {
  OnlineMoneyTransferProvider = 'Online Money Transfer Provider',
  FxBroker = 'FX Broker',
  Bank = 'Bank',
  PostOffice = 'Post Office',
  DigitalWallet = 'Digital Wallet',
  TravelCard = 'Travel Card',
  TravelCash = 'Travel Cash',
}

const TYPES_MAP = {
  BANK: ProviderType.Bank,
  DIGITAL_WALLET: ProviderType.DigitalWallet,
  FOREIGN_EXCHANGE_COMPANY: ProviderType.FxBroker,
  GLOBAL_MTO: ProviderType.OnlineMoneyTransferProvider,
  ONLINE_MTO: ProviderType.OnlineMoneyTransferProvider,
  OTHER_MTO: ProviderType.OnlineMoneyTransferProvider,
  POST_OFFICE: ProviderType.PostOffice,
  TRAVEL_CARD: ProviderType.TravelCard,
  TRAVEL_CASH: ProviderType.TravelCash,
}
